import { useDispatch } from 'react-redux'
import { ServiceOrderPhone } from 'components'
import { setStage } from 'slices/drawer'
import { FIREBASE_EVENTS, NEW_VIRTUAL_SUPPORT_STAGES } from 'app-constants'
import { useFirebaseEvent } from 'hooks'

export function PhoneSelection({ setContactNote, serviceOrderMassive }) {
  const dispatch = useDispatch()
  const { sendEvent } = useFirebaseEvent()

  function handleSelectedPhone(phone) {
    const event = serviceOrderMassive
      ? FIREBASE_EVENTS.UNITARY_WARNING_PHONE
      : FIREBASE_EVENTS.VIRTUAL_SUPPORT_PHONE_SELECTION

    setContactNote(phone)
    sendEvent(event)
    dispatch(setStage(NEW_VIRTUAL_SUPPORT_STAGES.SCHEDULE_CONFIRMATION))
  }

  return <ServiceOrderPhone onSelectPhone={handleSelectedPhone} />
}
